import { render } from "./HeaderPhone.vue?vue&type=template&id=406c3150&scoped=true"
import script from "./HeaderPhone.vue?vue&type=script&lang=js"
export * from "./HeaderPhone.vue?vue&type=script&lang=js"

import "./HeaderPhone.vue?vue&type=style&index=0&id=406c3150&scoped=true&lang=scss"

import exportComponent from "C:\\flexites\\1lombard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406c3150"]])

export default __exports__